/* eslint-disable import/prefer-default-export */
import dayjs from "dayjs";
import weekOfYear from "dayjs/plugin/weekOfYear";

dayjs.extend(weekOfYear);

export const getDaysInMonth = (
  day: number,
  m: number = new Date().getMonth(),
  y: number = new Date().getFullYear()
) => {
  const result: Date[] = [];
  let monday = dayjs().set("month", m).set("year", y).startOf("month").day(day);
  if (monday.date() > 7) {
    monday = monday.add(7, "d");
  }
  const month = monday.month();
  while (month === monday.month()) {
    result.push(monday.toDate());
    monday = monday.add(7, "d");
  }
  return result;
};
